import { MouseEventHandler } from "react";
import "./Button.scss";
import { Link, useNavigate } from "react-router-dom";
const Button = (props: {
  text: string;
  disabled?: boolean;
  linkTo?: string;
  type?: "cancel" | "inverse" | "navy";
  onClick?: MouseEventHandler<HTMLButtonElement>;
  submit?: boolean;
  linkState?: any;
  external?: boolean;
}) => {
  const navigate = useNavigate();
  const buttonClicked = () => {
    if (props.linkTo) {
      if (props.external) {
        window.open(props.linkTo, "_blank", "noopener,noreferrer");
      } else {
        navigate(props.linkTo);
      }
    }
  };

  if (props.linkTo) {
    if (props.external) {
      return (
        <div className="Button">
          <a href={props.linkTo} target="_blank" rel="noopener noreferrer" className={props.type}>{props.text}</a>
        </div>
      );
    }
    return (
      <div className="Button">
        <Link to={props.linkTo} className={props.type} state={props.linkState}>{props.text}</Link>
      </div>
    )
  }

  return (
    <div className="Button">
      <button
        disabled={props.disabled}
        onClick={props.onClick ? props.onClick : buttonClicked}
        className={props.type + ' ' + (props.disabled ? 'disabled' : '')}
        type={props.submit ? "submit" : "button"}
      >
        {props.text}
      </button>
    </div>
  );
};

export default Button;
